module.exports = __webpack_public_path__ + "img/Wow.1b5caeda.svg";